import $appConfig from "servicestack/config";
import $session from "servicestack/session";
import angular from "angular";

$session.get().then(function (session) {
  $appConfig.init($session);
  angular.element(document).ready(function () {
    angular
      .module("servicestack")
      .constant("apiPath", $appConfig.serviceUrl)
      .constant("firstSession", $session);
    var modules = ["emun.payments"];
    if (Array.isArray(window.ngModules))
      modules = modules.concat(window.ngModules);
    angular.bootstrap(document, modules);
  });
});
